/**
 * Keeps the string an editor was given while its content is unchanged. The editor serializes HTML its own way, so
 * otherwise a reverted edit, or a node view rewriting identical attributes on load, still changes the string.
 */
export default function createUnchangedValueTracker() {
  // Undefined until loaded: a `modelValue` can be null but never undefined, as the prop defaults to ''.
  let loadedValue;
  let loadedHTML = '';
  let lastValue;

  return {
    load(value, html) {
      loadedValue = value;
      loadedHTML = html;
      lastValue = value;
    },

    /** @returns the value to emit for the editor's current HTML */
    resolve(html) {
      lastValue = html === loadedHTML ? loadedValue : html;

      return lastValue;
    },

    /** The value last loaded or emitted, which the model holds unless the parent replaced it. */
    get value() {
      return lastValue;
    },
  };
}
